module.exports = __webpack_public_path__ + "img/7f2f717.jpg";